import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";

@Injectable()
export class FirstAidService extends ApiService {
    constructor(protected http: HttpService) {
        super(http);
        this.url = 'api/marketplace/skumasters/first-aid'
    }
}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/xpress-dev/src/app/shared/services/api/first-aid.service.ts